import { render, staticRenderFns } from "./healthDetail.vue?vue&type=template&id=3d1a1cae&scoped=true"
import script from "./healthDetail.vue?vue&type=script&lang=js"
export * from "./healthDetail.vue?vue&type=script&lang=js"
import style0 from "./healthDetail.vue?vue&type=style&index=0&id=3d1a1cae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1a1cae",
  null
  
)

export default component.exports